import React, { useState } from "react";
import { Button, Spinner } from "react-bootstrap";
import PropTypes from "prop-types";
import usePaymentsActions from "../hooks/usePaymentsActions";
import { usePersistentState } from "../hooks/usePersistentState";


const PaymentMethod = ({ requestId, paymentOptions, onSelectPayment}) => {
    const [loadingButton, setLoadingButton] = useState(null);
    const { payAgain } = usePaymentsActions();
    const [loading, setLoading] = useState(false);
    const [lastRequest, setLastRequest] = usePersistentState(`last-request-payment-id`, null, 72000)

    const onClickPayment = async (paymentType) => {        
        setLoadingButton(paymentType);
        setLoading(true);
        const response = await payAgain(requestId, paymentType);
        if (response.paymentUrl) {
          setLastRequest(requestId);
          window.location.href = response.paymentUrl;
        } else {
            console.log('23dic - requestCreate success', response);
            setLoadingButton(null);
            setLoading(false);
        }
        
    }

  return (
    <div className="text-center m-3">
      {paymentOptions && paymentOptions.map((option) => (
        <Button
          key={option.code}
          variant="payment-secondary"
          className="border px-4 py-3 text-center w-100 hover-effect"
          style={{ borderRadius: 8, marginBottom: 10, background: "#FFFFFF" }}
          onClick={() => onClickPayment(option.code)}
          disabled={loading}
        >
            {option.logo && (
              <img src={option.logo} alt={option.name} width={180} className="mb-2" />
            )}
            {option.text && (
              <p className="font-size-sm mb-0">{option.text}</p>
            )}
          {loadingButton === option.code && (
            <Spinner animation="border" size="sm" className="mt-2" />
          )}
        </Button>
      ))}
    </div>
  );
};

PaymentMethod.propTypes = {
  paymentOptions: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      logo: PropTypes.string,
      text: PropTypes.string,
    })
  ).isRequired,
  onSelectPayment: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  requestId: PropTypes.string.isRequired,
};

export default PaymentMethod;

